<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showTaxRateModal" :data="model" :title="$t('Tax Rate')" @show="onShow" size="sm"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <input-widget :label="false" :model="model" attribute="tax_rate" type="number" autofocus/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import TaxRateForm from "../../../models/TaxRateForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "TaxRateModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new TaxRateForm({}),
        showConfirmation: false
      }
    },
    computed: {
      ...mapState({
        showTaxRateModal: state => state.termsData.showTaxRateModal,
        taxRate: state => state.termsData.tax_rate
      }),
    },
    watch: {
      taxRate() {
        this.model = new TaxRateForm({tax_rate: this.taxRate});
      }
    },
    methods: {
      ...mapActions(['toggleTaxRateModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({tax_rate: this.model.tax_rate});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleTaxRateModal(false);
          this.$toast('success', this.$t('Tax Rate was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new TaxRateForm({tax_rate: this.taxRate});
      },
      onHidden() {
        this.model = new TaxRateForm();
        this.toggleTaxRateModal(false);
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>

